import { DataSharingPartnershipSchema } from "../types/dataSharingPartnership.js";
import { dataControllerCentral, dataControllerNorth, dataControllerSouth, } from "./organisations.js";
export const dataSharingPartnershipNorthCentral = DataSharingPartnershipSchema.parse({
    id: "196669ac-d94e-45ac-b492-3fec3c5c6075",
    name: "Data Sharing Partnership North Central",
});
export const dataSharingPartnershipSouthCentral = DataSharingPartnershipSchema.parse({
    id: "2f08221e-0f7f-4e08-8290-a57b854b437e",
    name: "Data Sharing Partnership South Central",
});
export const defaultDataSharingPartnerships = [
    {
        dataSharingPartnership: dataSharingPartnershipNorthCentral,
        dataControllerIds: [dataControllerNorth.id, dataControllerCentral.id],
    },
    {
        dataSharingPartnership: dataSharingPartnershipSouthCentral,
        dataControllerIds: [dataControllerCentral.id, dataControllerSouth.id],
    },
];
//# sourceMappingURL=dataSharingPartnerships.js.map